/**
 * @file Newsletter Form.
 */

/**
 * Newsletter Form functions.
 *
 * Runs js specific to the Newsletter Form template.
 */
const vNewsletterForm = () => {
	import('iframe-resizer/js/iframeResizer.contentWindow');

	/**
	 * 2024-07-24: Edits for Analytics.
	 *
	 * New event added in GTM listening for 'v-newsletter-submitted' message.
	 * However, thsi script is istening to 'beforeunload', which cuases
	 * the 'v-newsletter-submitted' message to be sent anytime the page
	 * is refreshed or navigated away from.
	 * Changed instead to listen for 'submit' event on the form.
	 */
	// window.addEventListener('beforeunload', () => {
	document.addEventListener('submit', () => {
		window.parent.postMessage('v-newsletter-submitted');
		/* if ('parentIFrame' in window) {
			window.parentIFrame.close();
		} */
	});
};

if (document.readyState !== 'loading') {
	vNewsletterForm();
} else {
	document.addEventListener('DOMContentLoaded', vNewsletterForm);
}
